﻿export interface IMatchHistory {
    id: number,
    matchHistoryTypeId: number,
    matchHistoryTypeName: string,
    swapNumber: string,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenter: string,
    transportMethod: string,
    cost: string,
    offerDateTime: string,
    originalMatchOfferDate?: string,
    deadlineDateTime: string,
    deadlineDateTimeLocal: string,
    deadlineDateTimeUtc: string,
    deadlineRemainingHours: number,
    targetSurgeryDate: string,
    requestDateTime: string,
    decisionDateTime: string,
    isAccepted: boolean,
    isClc: boolean,
    isCancelled: boolean,
    isStreamlinedCancellation: boolean,
    HasNoResponse: boolean
}
